export { MyTasksService } from './services/my-tasks';
export { MyTasksStore } from './stores/my-tasks';
export type { TaskItem, TaskSource, TaskStatus } from './types';
export { sortTaskItems, statusLabelToBucket } from './types';
export { extractTasksFromDoc } from './extract-tasks';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { DocsService } from '../doc';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { MyTasksService } from './services/my-tasks';
import { MyTasksStore } from './stores/my-tasks';

export function configureMyTasksModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .store(MyTasksStore, [DocsService, WorkspaceService, WorkspaceServerService])
    .service(MyTasksService, [MyTasksStore, WorkspaceServerService]);
}
